import React, { createContext, useEffect } from "react";
import socketManager from "./utils/socket";
import useAuth from "./hooks/useAuth";

export const SocketContext = createContext(null);

const SocketProvider = ({ children }) => {
  const { user } = useAuth();

  useEffect(() => {
    socketManager.connect();
    return () => {
      socketManager.disconnect();
    };
  }, []);

  useEffect(() => {
    if (user && user.id) {
      socketManager.joinUserRoom(user.id);
    }
  }, [user]);

  return (
    <SocketContext.Provider value={socketManager}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
